import {useEffect, useState} from 'react';
import {SETLANG_VALUE_CHANGED_EVENT} from '@wf-components/common-components-consumer';
import {EPIC_LOCALE_COOKIE_NAME} from '@wf-components/navigation-consumer';
import {getCookieValue} from './cookie.hooks';

export function useEpicLocale(): string | null {
	const [epicLocale, setEpicLocale] = useState<string | null>(null);

	useEffect(() => {
		const cb = () => {
			void (async () => {
				const cookieValue = getCookieValue(EPIC_LOCALE_COOKIE_NAME);
				setEpicLocale(cookieValue ?? null);
			})();
		};
		cb();

		window.addEventListener(SETLANG_VALUE_CHANGED_EVENT, cb);
		return () => {
			window.removeEventListener(SETLANG_VALUE_CHANGED_EVENT, cb);
		};
	}, []);
	return epicLocale;
}
